module.exports = __webpack_public_path__ + "static/media/fitness.048c98e3.jpg";